import { useTransactionCertificateStore } from "../../../../store/transaction-certificates.store";

export interface FacilityInformation {
  facilityId?: string;
  isMainSite: string;
  facilityNo?: string;
  facilityType: string;
  facilityOsId:string;
  facilityProductionCapacity?: number;
  facilityAdditionalScopes:string;
  facilityTeId?: string;
  facilityStandard?: string[];
  facilityName: string;
  facilityAddress1: string;
  facilityAddress2?: string;
  facilityAddress3?: string;
  facilityAddedDate:string;
  facilityRemovedDate?:string;
  facilityLastAuditDate?:string;
  /** UI-only: derived from facilityLastAuditDate === '1900-01-01'. Not sent to API. */
  facilityNotAudited?: boolean;
  facilityPostcode: string;
  facilityTown: string;
  facilityCountryOrArea: string;
  facilityStateOrProvince: string;
  facilityCbOfIndependentlyCertifiedSubcontractor: string;
}

export interface FacilityProcessDetails {
  facilityProcessCategoryCode: string;
  facilityProcessCategoryCodeDescription: string;
  facilityProcessCategoryUserSpecificTerm:string;
}

export interface FacilityFarmCapacityInformation {
  facilityFarmRawMaterialCode: string;
  facilityFarmRawMaterialCapacity: string;
  facilityFarmRawMaterialCodeDescription:string;
  facilityFarmRawMaterialNumberOfAnimals?: string;
}

export interface CompleteFacilityForm {
  facilityInformation: FacilityInformation;
}

export interface IfacilityDetailsReq {
  scId: string;
  
    isMainSite: string;
    facilityNo: string;
    facilityStandard: string[];
    facilityType: string;
    // facilitySubcontractorLicenseNo: string;
    facilityOsId: string;
    facilityName: string;
    facilityTeId: string;
    facilityAddress1: string;
    facilityAddress2: string;
    facilityAddress3: string;
    facilityPostcode: string;
    facilityTown: string;
    facilityStateOrProvince: string;
    facilityCountryOrArea: string;
    facilityCbOfIndependentlyCertifiedSubcontractor: string;
    // facilityExpiryDateOfIndependentlyCertifiedSubcontractor: string;
    facilityAddedDate:string;
    facilityRemovedDate:string;
    scFacilityReAdded?: boolean;
    facilityLastAuditDate: string;
    facilityFarmCapacityInformation: string[];
    facilityProductionCapacity?:number;
    facilityAdditionalScopes:string;
    facilityProcessDetails: {
      facilityProcessCategoryCode: string;
      facilityProcessCategoryCodeDescription:string;
      facilityProcessCategoryUserSpecificTerm: string;
    }[];
  
}

export const initFacilityDetailsReq: IfacilityDetailsReq = {
  scId: '',
  
    isMainSite: '',
    facilityNo: '',
    facilityStandard: [],
    facilityType: '',
    // facilitySubcontractorLicenseNo: '',
    facilityOsId: '',
    facilityName: '',
    facilityTeId: '',
    facilityAddress1: '',
    facilityAddress2: '',
    facilityAddress3: '',
    facilityPostcode: '',
    facilityTown: '',
    facilityStateOrProvince: '',
    facilityCountryOrArea: '',
    facilityCbOfIndependentlyCertifiedSubcontractor: '',
    // facilityExpiryDateOfIndependentlyCertifiedSubcontractor: '',
    facilityAddedDate:'',
    facilityRemovedDate:'',
    facilityLastAuditDate: '',
    facilityAdditionalScopes:'',
    facilityFarmCapacityInformation: [],
    facilityProcessDetails: [{
      facilityProcessCategoryCode: '',
      facilityProcessCategoryUserSpecificTerm: '',
      facilityProcessCategoryCodeDescription:''
    }],
  
};

export const mapToFacilityDetailsReq = (
  data: any,
  SC_ID: string,
  facilityId?: string|null,
  isPostCreation?: string,
): any => {
  // If data is not an array, wrap it into one
  // alert("23---"+facilityId)
  
  const facilityTypeOptions = [
    { value: 'MF', label: 'Main Facility/Main Site' },
    { value: 'FA', label: 'Facility/Subsequent Site' },
    { value: 'AS', label: 'Associated Subcontractor' },
    { value: 'CS', label: 'Independently Certified Subcontractor' }
  ]
  const facilityStandardCodesOptions = [
    { label: "Organic Content Standard", value: "OCS" }, // Represents "Valid"
    { label: "Global Recycled Standard", value: "GRS" }, // Represents "Expired" 
    { label: "Recycled Claim Standard", value: "RCS" }, // Represents "Suspended"
    { label: "Responsible Down Standard", value: "RDS" }, // Represents "Withdrawn"
    { label: "Responsible Wool Standard", value: "RWS" }, // Represents "Withdrawn"
    { label: "Responsible Mohair Standard", value: "RMS" }, // Represents "Withdrawn"
    { label: "Responsible Alpaca Standard", value: "RAS" }, // Represents "Withdrawn"
    { label: "Content Claim Standard", value: "CCS" }, // Represents "Withdrawn"
    { label: "SFA", value: "SFA" }, // Represents "Withdrawn"
    { label: "Global Organic Textile Standard", value: "GOTS" }, // Represents "Withdrawn"
  ];
  let stateData = useTransactionCertificateStore.getState();
  const normalizeNa = (v?: string) => v && ['na', 'NA', 'Na', 'nA'].includes(v.trim()) ? 'na' : (v || '');

  return {
    scId: SC_ID,
    ...(facilityId && { facilityId }),
      isMainSite: data.facilityInfo?.facilityType === 'MF' ? 'Y' : 'N',
      // facilityNo: data.facilityInfo?.facilityNo || '',
      facilityStandard: data.facilityInfo?.facilityStandard || [],
      facilityStandardDescription: facilityStandardCodesOptions
      .filter(option => data.facilityInfo.facilityStandard.includes(option.value))
      .map(option => option.label.trim()) || [],
      facilityType: data.facilityInfo?.facilityType || '',
      facilityTypeDescription: facilityTypeOptions.find((option: any) => option.value === (data.facilityInfo.facilityType ?? ""))?.label.trim() ?? "",
      facilityName: data.facilityInfo?.facilityName || '',
      facilityTeId: data.facilityInfo?.facilityTeId || '',
      facilityStreetAddress: data.facilityInfo?.facilityAddress1 || '',
      // facilityAddress2: data.facilityInfo?.facilityAddress2 || '',
      // facilityAddress3: data.facilityInfo?.facilityAddress3 || '',
      facilityPostcode: normalizeNa(data.facilityInfo?.facilityPostcode),
      facilityAdditionalScopes: data.facilityInfo?.facilityAdditionalScopes || '',
      facilityTown: normalizeNa(data.facilityInfo?.facilityTown),
      facilityStateOrProvince: data.facilityInfo?.facilityStateOrProvince || '',
      facilityStateOrProvinceDescription: stateData.getStates.find((option: any) => option.value === (data.facilityInfo.facilityStateOrProvince ?? ""))?.label.trim() ?? "",
      facilityCountryOrArea: data.facilityInfo?.facilityCountryOrArea || '',
      facilityCountryOrAreaDescription: stateData.getCountries.find((option: any) => option.value === (data.facilityInfo.facilityCountryOrArea ?? ""))?.label.trim() ?? "",

      facilityCbOfIndependentlyCertifiedSubcontractor: data.facilityInfo?.facilityCbOfIndependentlyCertifiedSubcontractor || '',
      facilityOsId:data?.facilityInfo?.facilityOsId,
      facilityCbOfIndependentlyCertifiedSubcontractorDescription: stateData.getCBLicensingsCodes.find((option: any) => option.value === (data.facilityInfo.certificationBody ?? ""))?.label.trim() ?? "",
      facilityAddedDate: data.facilityInfo?.facilityAddedDate || '',
      facilityRemovedDate: data.facilityInfo?.facilityRemovedDate || '',
      scFacilityReAdded: (data.facilityInfo?.facilityAddedDate && data.facilityInfo?.facilityRemovedDate) ? 
        new Date(data.facilityInfo.facilityAddedDate) > new Date(data.facilityInfo.facilityRemovedDate) : false,
      facilityLastAuditDate: data.facilityInfo?.facilityLastAuditDate || '',
      ...(data.facilityInfo?.facilityProductionCapacity && data.facilityInfo.facilityProductionCapacity !== '' && { 
        facilityProductionCapacity: parseFloat(data.facilityInfo.facilityProductionCapacity) 
      }),
      isPostCreation: isPostCreation || "yes",
      facilityFarmCapacityInformation: data?.facilityFarmCapacityInformation?.map((item: any) => {
        const payloadItem = { ...item };

        // Backend Pydantic model requires facilityFarmRawMaterialCapacity and
        // facilityFarmRawMaterialNumberOfAnimals as non-Optional int on EVERY row.
        // Previously these were deleted when empty, causing a 422 "Field required" error.
        // Now we send 0 as the safe integer default when no value has been entered.
        if (payloadItem.facilityFarmRawMaterialCapacity === "" || payloadItem.facilityFarmRawMaterialCapacity == null) {
          payloadItem.facilityFarmRawMaterialCapacity = 0;
        } else {
          payloadItem.facilityFarmRawMaterialCapacity = parseInt(String(payloadItem.facilityFarmRawMaterialCapacity), 10);
        }

        // Always present — 0 for RM codes that don't require an animal count (e.g. RM0032).
        if (payloadItem.facilityFarmRawMaterialNumberOfAnimals === "" || payloadItem.facilityFarmRawMaterialNumberOfAnimals == null) {
          payloadItem.facilityFarmRawMaterialNumberOfAnimals = 0;
        } else {
          payloadItem.facilityFarmRawMaterialNumberOfAnimals = parseInt(String(payloadItem.facilityFarmRawMaterialNumberOfAnimals), 10);
        }

        return payloadItem;
      }) || [],
      facilityProcessInformation: data.facilityProcessInformation?.map((process: any) => ({
        facilityProcessCategoryCode: process.facilityProcessCategoryCode || '',
        facilityProcessCategoryCodeDescription:stateData.getFacilityProcessCategoryCodes.find((option: any) => option.value === (process.facilityProcessCategoryCode ?? ""))?.label.trim() ?? "",
        facilityProcessCategoryUserSpecificTerm: process.facilityProcessCategoryUserSpecificTerm || '',
        actions: process.actions || '',
      })) || [],
  };
};


export const mapToFacilityDetailsDeteleSaveReq = (facility: any, SC_ID: string, postCreation?: string): IfacilityDetailsReq => {
  const normalizeNa = (v?: string) => v && ['na', 'NA', 'Na', 'nA'].includes(v.trim()) ? 'na' : (v || '');

  return {
    scId: SC_ID,
    
      isMainSite: facility?.facilityType === 'MF' ? 'Y' : 'N',
      facilityNo: facility.facilityNo || '',
      facilityStandard: facility.facilityStandard || [],
      facilityType: facility.facilityType || '',
      // facilitySubcontractorLicenseNo: facility.subcontractorLicenseNo || '',
      facilityOsId: facility.facilityOsId || '',
      facilityName: facility.facilityName || '',
      facilityTeId: facility.facilityTeId || '',
      facilityAddedDate:facility?.facilityAddedDate||'',
      facilityRemovedDate:facility?.facilityRemovedDate||'',
      scFacilityReAdded: (facility?.facilityAddedDate && facility?.facilityRemovedDate) ? 
        new Date(facility.facilityAddedDate) > new Date(facility.facilityRemovedDate) : false,
      facilityAddress1: facility.facilityAddress1 || '',
      facilityAddress2: facility.facilityAddress2 || '',
      facilityAddress3: facility.facilityAddress3 || '',
      facilityPostcode: normalizeNa(facility.facilityPostcode),
      facilityTown: normalizeNa(facility.facilityTown),
      facilityStateOrProvince: facility.facilityStateOrProvince || '',
      facilityCountryOrArea: facility.facilityCountryOrArea || '',
      facilityCbOfIndependentlyCertifiedSubcontractor: facility.certificationBody || '',
      // facilityExpiryDateOfIndependentlyCertifiedSubcontractor: facility.expiryDate || '',
      facilityLastAuditDate: facility.facilityLastAuditDate || '',
      facilityFarmCapacityInformation: facility.farmCapacity || [],
      ...(facility?.facilityProductionCapacity && facility.facilityProductionCapacity !== '' && { 
        facilityProductionCapacity: parseFloat(facility.facilityProductionCapacity) 
      }),
      facilityAdditionalScopes:facility?.facilityAdditionalScopes||'',
      facilityProcessDetails: facility.facilityProcessDetails.map((process: any) => ({
        facilityProcessCategoryCode: process.facilityProcessCategoryCode || '',
        facilityProcessCategoryCodeDescription:useTransactionCertificateStore.getState().getFacilityProcessCategoryCodes.find((option: any) => option.value === (process.facilityProcessCategoryCode ?? ""))?.label.trim() ?? "",
        facilityProcessCategoryUserSpecificTerm: process.facilityProcessUserSpecificTerm || '',
        actions: '',
      })),
  
  };
};
export interface FacilityInformation {
  facilityId?: string;
  isMainSite: string;
  facilityNo?: string;
  facilityType: string;
  // facilityOARId: string;
  facilityProductionCapacity?: number;
  facilityAdditionalScopes:string;
  facilityTeId?: string;
  facilityStandard?: string[];
  facilityName: string;
  facilityOsId:string;
  facilityAddress1: string;
  facilityAddress2?: string;
  facilityAddress3?: string;
  facilityAddedDate:string;
  facilityRemovedDate?:string;
  facilityLastAuditDate?:string;
  /** UI-only: derived from facilityLastAuditDate === '1900-01-01'. Not sent to API. */
  facilityNotAudited?: boolean;
  facilityPostcode: string;
  facilityTown: string;
  facilityCountryOrArea: string;
  facilityStateOrProvince: string;
  facilityCbOfIndependentlyCertifiedSubcontractor: string;
  // certificationBody: string;
}

export interface FacilityProcessDetails {
  facilityProcessCategoryCode: string;
  facilityProcessCategoryCodeDescription: string;
  facilityProcessCategoryUserSpecificTerm:string;
}

export interface FacilityState {
  facilityInfo: FacilityInformation;
  facilityProcessInformation: FacilityProcessDetails[];
  facilityFarmCapacityInformation:FacilityFarmCapacityInformation[];
}

type InputData = {
  scId: string;
  facilityDetails: {
    isMainSite: string;
    facilityNo: string;
    facilityType: string;
    facilityOarId: string;
    facilityLastAuditDate: string;
    facilityFarmCapacity?: string[];
    facilityFarmRawMaterialNumberOfAnimals?: string[];
    facilityTeId?: string;
    facilityStandard?: string[];
    facilityName: string;
    facilityAddress1: string;
    facilityAddress2?: string;
    facilityAddress3?: string;
    facilityPostcode: string;
    facilityTown: string;
    facilityCountryOrArea: string;
    facilityStateOrProvince?: string;
    facilitySubcontractorLicenseNo?: string;
    facilityCbOfIndependentlyCertifiedSubcontractor: string;
    facilityExpiryDateOfIndependentlyCertifiedSubcontractor: string;
    facilityProcessDetails: {
      facilityProcessCategoryCode: string;
      facilityProcessCategoryUserSpecificTerm: string;
    }[];
  }[];
};

export const mapFacilityDetails = (facilityDetails: any[]): any[] => {
  if (!Array.isArray(facilityDetails)) {
    throw new Error("Invalid facility details: Expected an array");
  }

  return facilityDetails.map((facility, index) => {
    // Validate required fields

    return {
      facilityInfo: {
        facilityTeId:facility?.facilityTeId||"",
        facilityId: facility.facilityId || "",
        facilityNo: facility.facilityNo,
        facilityType:facility.facilityType,
        facilityAddedDate: facility.facilityAddedDate ?? "",
        facilityRemovedDate: facility.facilityRemovedDate ?? "",
        facilityName: facility.facilityName,
        facilityPostcode: facility.facilityPostcode ?? "",
        facilityCountryOrArea: facility.facilityCountryOrArea ?? "",
        facilityStandard: facility.facilityStandard || [],
      },
      facilityProcessInformation: facility.facilityProcessInformation?.map((p: any) => ({
        facilityProcessCategoryCode: p.facilityProcessCategoryCode,
        facilityProcessCategoryCodeDescription: p.facilityProcessCategoryCodeDescription,
        facilityProcessCategoryUserSpecificTerm: p.facilityProcessCategoryUserSpecificTerm,
      })) || [],
      facilityProcessDetails: [],
    };
  });
};

